import * as React from 'react';
import { useStoreActions } from 'easy-peasy';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import { Post } from '../../services/http';

export default function GetStartedPage() {
    const [campaigns, setCampaigns] = React.useState(false);
    const openInfoPopup = useStoreActions((actions) => actions.open);

    const send = async () => {
        const fromName = document.getElementById('fromName').value;
        const fromEmail = document.getElementById('fromEmail').value;
        const phone = document.getElementById('phone').value;
        const howHearAboutTzedaka = document.getElementById('howHearAboutTzedaka').value;
        const aboutYourCampaigns = document.getElementById('aboutYourCampaigns').value;
        console.log('fromName', fromName);
        const result = await Post('/api/donation/CreateContactUsItem', { fromName, fromEmail, phone, howHearAboutTzedaka, aboutYourCampaigns });
        console.log('result', result);
        if (result.result) {
            openInfoPopup({ notice: 'הפניה נשלחה בהצלחה', reload: false });
        } else {
            openInfoPopup({ notice: result.message, reload: false });
        }
    };

    return (
        <main className="main">
        <section className="head-section" style={{ backgroundImage: 'url(/img/background2.jpg)' }}>
            <div className="container">
                <div className="head-section__devider head-section__devider--1 _anim-items _anim-no-hide _fadeDown" data-animate-delay="02"><span>?</span></div>
                <div className="head-section__subtitle _anim-items _anim-no-hide _fadeDown" data-animate-delay="03">Are you looking to raise money for yourself or someone else, <br /><strong>and don’t know where to start? </strong></div>
                <div className="head-section__devider head-section__devider--2 _anim-items _anim-no-hide _fadeDown" data-animate-delay="04"><span>?</span></div>
                <div className="head-section__subtitle _anim-items _anim-no-hide _fadeDown" data-animate-delay="05">Are you looking to start a campaign, <br />
                <strong>but it seems too overwhelming?</strong></div>
            </div>
        </section>
        
        <div className="container">
            <div className="get-started">
                <h1 className="get-started__title _anim-items _fadeScale" data-animate-delay="06"><span>WE CAN HELP YOU!</span></h1>
                <h2 className="get-started__subtitle _anim-items  _fadeUp" data-animate-delay="07">We will guide you through the process!</h2>

                <div className="get-started__content">
                    <p class="_anim-items  _fadeUp" data-animate-delay="01"><strong className="color-info">We are here to help your cause succeed!</strong> <br />
                    <strong className="color-info">To help you reach your goal!</strong> <br />
                    <span className="font-600">We don’t charge you any fees or percentages!</span> Your only cost will be for marketing and advertising your campaign, which will help your campaign succeed. <br />
                    We want to make it easier for you to start, <span className="font-600">so you do not need to pay those expenses upfront!</span> Instead, it will be deducted from the funds raised, once you are ready to cash out.</p>

                    <div className="read-more text-center _anim-items  _fadeUp" data-animate-delay="02">
                        <a href="#" className="read-more-btn"><span>Read More</span></a>
                    </div>

                    <p className="text-center _anim-items  _fadeUp" data-animate-delay="03">We offer many services to help your campaign succeed. You can pick a few or do them all.</p>
                    <div className="read-more text-center _anim-items  _fadeUp" data-animate-delay="04">
                        <a href="#" className="read-more-btn read-more-btn--rotate"><span>Read More</span></a>
                    </div>
                </div>	
            </div>
        </div>

        <section className="steps">
            <div className="container">
                <div className="steps__wrap">
                    <div className="steps__item item-step _active _anim-items" data-animate-delay="02" data-step="01">
                        <div className="item-step__img _anim-items  _fadeRight" data-animate-delay="02">
                            <img src="img/step1.png" alt="" />
                        </div>
                        <div className="item-step__text _anim-items  _fadeRight" data-animate-delay="04">
                            <strong className="color-info">Gather</strong> all the info about the cause. That includes the story, footage, and endorsements.
                        </div>
                    </div>
                    <div className="steps__item item-step item-step--reverse _anim-items" data-animate-delay="02" data-step="02">
                        <div className="item-step__img _anim-items  _fadeRight" data-animate-delay="02">
                            <img src="img/step2.png" alt="" />
                        </div>
                        <div className="item-step__text _anim-items  _fadeLeft" data-animate-delay="04">
                            <strong className="color-info">Fill out</strong>  the contact form below and we will get back to you as soon as possible.
                        </div>
                    </div>
                    <div className="steps__item item-step _anim-items" data-animate-delay="02" data-step="03">
                        <div className="item-step__img _anim-items  _fadeLeft" data-animate-delay="02">
                            <img src="img/step3.png" alt="" />
                        </div>
                        <div className="item-step__text _anim-items  _fadeRight" data-animate-delay="04"> 
                            <strong className="color-info">Sit back</strong> and watch the progress.
                        </div>
                    </div>
                    <div className="steps__item item-step-end _anim-items" data-animate-delay="02">
                        <div className="item-step-end__img _anim-items  _fadeUp" data-animate-delay="02">
                            <img src="img/end.png" alt="" />
                        </div>
                        <div className="item-step-end__text _anim-items  _fadeUp" data-animate-delay="04">END!</div>
                    </div>
                </div>		
            </div>
        </section>

        <section className="send section">
            <div className="container">
                <div className="section__head">
                    <h2 className="section__title _anim-items  _fadeScae" data-animate-delay="02"><span>Campaign form</span></h2>
                </div>         
                
                <div className="send-form send-form--campaign _anim-items  _fadeUp" data-animate-delay="04">
                    <div className="send-form__item">
                        <input type="text" className="form-input" id="fromName" placeholder="Name:" />
                    </div>
                    <div className="send-form__item">
                        <input type="text" className="form-input" id="fromEmail" placeholder="Email:" />
                    </div>
                    <div className="send-form__item">
                        <input type="text" className="form-input" id="phone" placeholder="Phone:" />
                    </div>
                    <div className="send-form__message">
                        <textarea className="form-input" id="howHearAboutTzedaka" placeholder="How dud you hear about the world of tzedaka?"></textarea>
                    </div>
                    <div className="send-form__message">
                        <textarea className="form-input" id="aboutYourCampaigns" placeholder="About  your campaigns:"></textarea>
                    </div>
                    <div className="send-form__button">
                        <button type="submit" className="form-btn form-btn--block" onClick={send}>SEND</button>
                    </div>
                    
                </div>
            </div>
        </section>
        
    </main>
    );
}
